import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export type SalesforceStageKey =
	| 'New'
	| 'Closed Won'
	| 'Lost'
	| 'Invalid Opp'
	| 'Closed Won (Auto Linked)'
	| 'Closed Lost (Send Survey)'
	| 'No Opportunity'
	| 'Develop Opportunity'
	| 'Qualify Opportunity';

export const i18n: Record<SalesforceStageKey, MessageDescriptor> =
	defineMessages<SalesforceStageKey>({
		New: {
			id: 'search-page.salesforce.filter.stage.new',
			defaultMessage: 'New',
			description: 'New stage for a Salesforce opportunity',
		},
		'Closed Won': {
			id: 'search-page.salesforce.filter.stage.closed-won',
			defaultMessage: 'Closed Won',
			description: 'Closed Won stage for a Salesforce opportunity',
		},
		Lost: {
			id: 'search-page.salesforce.filter.stage.lost',
			defaultMessage: 'Lost',
			description: 'Lost stage for a Salesforce opportunity',
		},
		'Invalid Opp': {
			id: 'search-page.salesforce.filter.stage.invalid-opp',
			defaultMessage: 'Invalid Opp',
			description: 'Invalid Opp stage for a Salesforce opportunity',
		},
		'Closed Won (Auto Linked)': {
			id: 'search-page.salesforce.filter.stage.closed-won-auto-linked',
			defaultMessage: 'Closed Won (Auto Linked)',
			description: 'Closed Won (Auto Linked) stage for a Salesforce opportunity',
		},
		'Closed Lost (Send Survey)': {
			id: 'search-page.salesforce.filter.stage.closed-lost-send-survey',
			defaultMessage: 'Closed Lost (Send Survey)',
			description: 'Closed Lost (Send Survey) stage for a Salesforce opportunity',
		},
		'No Opportunity': {
			id: 'search-page.salesforce.filter.stage.no-opportunity',
			defaultMessage: 'No Opportunity',
			description: 'No Opportunity stage for a Salesforce opportunity',
		},
		'Develop Opportunity': {
			id: 'search-page.salesforce.filter.stage.develop-opportunity',
			defaultMessage: 'Develop Opportunity',
			description: 'Develop Opportunity stage for a Salesforce opportunity',
		},
		'Qualify Opportunity': {
			id: 'search-page.salesforce.filter.stage.qualify-opportunity',
			defaultMessage: 'Qualify Opportunity',
			description: 'Qualify Opportunity stage for a Salesforce opportunity',
		},
	});
